(function ($) {
  'use strict';

  $(function () {

    /* ---------- Hero slider ---------- */
    var $heroSlides = $('.sk-hero__slide');
    var $heroDots = $('.sk-hero__tab');
    var heroIndex = 0;
    var heroTimer = null;

    var heroPreload = null;
    /* Hidden slides' images are deferred (data-defer-*, see hero.liquid) so they don't compete with the
       first slide's (LCP) image: each is loaded when its slide is shown, and the next one 3.5s before
       the auto-rotation reaches it. */
    function loadHeroImage(i) {
      $heroSlides.eq(i).find('img[data-defer-src]').each(function () {
        if (this.dataset.deferSrcset) this.srcset = this.dataset.deferSrcset;
        this.src = this.dataset.deferSrc;
        this.removeAttribute('data-defer-src');
        this.removeAttribute('data-defer-srcset');
      });
    }
    function preloadNextHero() {
      clearTimeout(heroPreload);
      heroPreload = setTimeout(function () { loadHeroImage((heroIndex + 1) % $heroSlides.length); }, 1500);
    }

    function showHero(index) {
      heroIndex = (index + $heroSlides.length) % $heroSlides.length;
      loadHeroImage(heroIndex);
      preloadNextHero();
      $heroSlides.each(function (i) { $(this).toggleClass('active', i === heroIndex); });
      $heroDots.each(function (i) { $(this).toggleClass('active', i === heroIndex).attr('aria-selected', i === heroIndex ? 'true' : 'false'); });
    }

    function startHeroTimer() {
      stopHeroTimer();
      heroTimer = setInterval(function () { showHero(heroIndex + 1); }, 5000);
    }
    function stopHeroTimer() {
      if (heroTimer) { clearInterval(heroTimer); heroTimer = null; }
    }

    if ($heroSlides.length) {
      preloadNextHero();
      startHeroTimer();
      $heroDots.each(function () {
        var $dot = $(this);
        $dot.on('click', function () {
          showHero(parseInt($dot.data('index'), 10));
          startHeroTimer();
        });
      });
      $heroSlides.each(function () {
        var $slide = $(this);
        var $img = $slide.find('.sk-hero__slide-img');
        if (!$img.length) return;
        $slide.on('mouseenter', function () { if ($img.data('hover-src')) $img.attr('src', $img.data('hover-src')); });
        $slide.on('mouseleave', function () { if ($img.data('src')) $img.attr('src', $img.data('src')); });
      });
    }

    /* ---------- Reels scroll buttons ---------- */
    var $reelsTrack = $('#reels-track');
    if ($reelsTrack.length) {
      $('#reels-prev').on('click', function () { $reelsTrack.animate({ scrollLeft: '-=260' }, 300); });
      $('#reels-next').on('click', function () { $reelsTrack.animate({ scrollLeft: '+=260' }, 300); });
    }

    /* ---------- Products carousel ---------- */
    var $productSlides = $('.sk-product-slide');
    var $productDots = $('.sk-products-carousel__dot');
    var productIndex = 0;

    function showProduct(index) {
      productIndex = (index + $productSlides.length) % $productSlides.length;
      $productSlides.each(function (i) { $(this).toggleClass('active', i === productIndex); });
      $productDots.each(function (i) { $(this).toggleClass('active', i === productIndex); });
    }

    $('#products-prev').on('click', function () { showProduct(productIndex - 1); });
    $('#products-next').on('click', function () { showProduct(productIndex + 1); });
    $productDots.each(function () {
      var $dot = $(this);
      $dot.on('click', function () { showProduct(parseInt($dot.data('index'), 10)); });
    });

    /* Pack selector (Single vs Buy 2 Get 1 FREE) */
    $('.sk-pack-selector').each(function () {
      var $selector = $(this);
      var idx = $selector.data('product-index');
      var $priceEl = $('#product-price-' + idx);
      var $mrpEl = $('#product-mrp-' + idx);
      var $saveEl = $('#product-save-' + idx);
      var $imgEl = $('#product-img-' + idx);
      var $noteEl = $('#pack-note-' + idx);
      $selector.find('.sk-pack-option').each(function () {
        var $opt = $(this);
        $opt.on('click', function () {
          $selector.find('.sk-pack-option').removeClass('selected');
          $opt.addClass('selected');
          var price = parseFloat($opt.data('price'));
          var mrp = parseFloat($opt.data('mrp'));
          $priceEl.text(window.SK.fmt(price));
          if ($mrpEl.length) {
            $mrpEl.text('MRP ' + window.SK.fmt(mrp));
            $mrpEl.prop('hidden', mrp <= price);
          }
          window.SK.swapImg($imgEl[0], $opt[0]);
          $noteEl.text($opt.data('pack') === 'b2g1' ? $selector.data('note-b2g1') : $selector.data('note-single'));
          if ($saveEl.length) {
            var isB2g1 = $opt.data('pack') === 'b2g1';
            $saveEl.text(isB2g1 ? $selector.data('save-b2g1') : '');
            $saveEl.prop('hidden', !isB2g1);
          }
          var $addBtn = $('.js-add-to-cart[data-index="' + idx + '"]');
          var $buyBtn = $('.js-buy-now[data-index="' + idx + '"]');
          $addBtn.add($buyBtn).each(function () {
            $(this).attr('data-price', $opt.data('price')).attr('data-img', $opt.data('img')).attr('data-variant-id', $opt.attr('data-variant-id'));
          });
        });
      });
    });

    /* ---------- Best-value offer hover-swap ---------- */
    $('.sk-offer-card__img').each(function () {
      var $img = $(this);
      var $card = $img.closest('.sk-offer-card');
      if (!$card.length) return;
      $card.on('mouseenter', function () { if ($img.data('hover-src')) $img.attr('src', $img.data('hover-src')); });
      $card.on('mouseleave', function () { if ($img.data('src')) $img.attr('src', $img.data('src')); });
    });

    /* ---------- Add to cart / buy now ---------- */
    // Buttons carry the Shopify variant id (updated by the pack selector above).
    $('.js-add-to-cart').on('click', function () {
      window.SK.addToCart({ id: $(this).attr('data-variant-id') }, false);
    });
    $('.js-buy-now').on('click', function () {
      window.SK.addToCart({ id: $(this).attr('data-variant-id') }, true, this);
    });

    /* ---------- Ingredient explorer ---------- */
    var $ingSets = $('.sk-ing-set');
    function pad2(n) { return (n < 10 ? '0' : '') + n; }

    function initIngSwiper($set) {
      var el = $set.find('.js-ing-swiper').get(0);
      if (!el || el.swiper || !window.Swiper) return;
      var total = Number($set.data('total')) || 0;
      var $count = $set.find('.js-ing-count');
      var $thumbs = $set.find('.sk-ing-thumb');
      var sw = new window.Swiper(el, {
        slidesPerView: 1.12, spaceBetween: 14, grabCursor: true, watchOverflow: true, observer: true, observeParents: true,
        navigation: { prevEl: $set.find('.js-ing-prev').get(0), nextEl: $set.find('.js-ing-next').get(0) },
        breakpoints: { 600: { slidesPerView: 2.1, spaceBetween: 16 }, 1024: { slidesPerView: 3, spaceBetween: 22 } }
      });
      function sync() {
        var i = sw.isEnd ? Math.max(0, total - 1) : sw.activeIndex;
        $count.text(pad2(i + 1) + ' / ' + pad2(total));
        $thumbs.each(function (n) { $(this).toggleClass('active', n === i); });
      }
      sw.on('slideChange', sync);
      sw.on('reachEnd', sync);
      sw.on('fromEdge', sync);
      $thumbs.on('click', function () {
        var n = Number($(this).attr('data-slide')) || 0;
        sw.slideTo(n);
        $count.text(pad2(n + 1) + ' / ' + pad2(total));
        $thumbs.each(function (k) { $(this).toggleClass('active', k === n); });
      });
      sync();
    }

    function ensureIngSwipers() {
      if (!window.Swiper) return false;
      $ingSets.filter('.active').each(function () { initIngSwiper($(this)); });
      return true;
    }
    if (!ensureIngSwipers()) {
      var ingTries = 0;
      var ingTimer = setInterval(function () {
        if (ensureIngSwipers() || ++ingTries > 80) clearInterval(ingTimer);
      }, 150);
    }

    $('#ing-product-select').on('change', function () {
      var group = String($(this).val());
      $ingSets.each(function () { $(this).toggleClass('active', String($(this).data('group')) === group); });
      ensureIngSwipers();
      $ingSets.filter('.active').find('.js-ing-swiper').each(function () { if (this.swiper) this.swiper.update(); });
    });

    /* ---------- Ingredient research drawer (snippets/ing-drawer.liquid) ---------- */
    function readIngCard(card) {
      var $c = $(card);
      var studies = [];
      try { studies = JSON.parse($c.attr('data-studies') || '[]'); } catch (err) { studies = []; }
      return {
        name: $c.attr('data-name') || '', botanical: $c.attr('data-botanical') || '', img: $c.attr('data-img') || '',
        use: $c.attr('data-use') || '', ayurveda: $c.attr('data-ayurveda') || '', research: $c.attr('data-summary') || '', safety: $c.attr('data-safety') || '',
        studies: studies
      };
    }
    function openIngDrawer(card) {
      if (!window.SK || !window.SK.ingDrawer) return;
      var $set = $(card).closest('.sk-ing-set');
      var cards = $set.find('.js-ing-item').get();
      window.SK.ingDrawer.open({
        label: $('#ing-product-select option:selected').text().trim(),
        items: cards.map(readIngCard),
        index: cards.indexOf(card),
        onChange: function (i) {
          var sw = $set.find('.js-ing-swiper').get(0);
          if (sw && sw.swiper) sw.swiper.slideTo(i);
        }
      });
    }
    $('.js-ing-item').on('click', function () { openIngDrawer(this); });
    $('.js-ing-item').on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openIngDrawer(this); }
    });

    /* ---------- Journey timeline ---------- */
    var $jrYears = $('.jr-year');
    var $jrCards = $('.jr-card');
    var $jrScroll = $('#journey-scroll');
    var jrIndex = 0;

    function setJourneyActive(index) {
      jrIndex = (index + $jrCards.length) % $jrCards.length;
      $jrYears.each(function (i) { $(this).toggleClass('active', i === jrIndex); });
      $jrCards.each(function (i) { $(this).toggleClass('active', i === jrIndex); });
    }
    function scrollToCard(index) {
      var $card = $jrCards.eq(index);
      if ($card.length && $jrScroll.length) {
        $jrScroll.animate({ scrollLeft: $card[0].offsetLeft - $jrScroll[0].offsetLeft }, 300);
      }
    }
    $jrYears.each(function () {
      var $y = $(this);
      $y.on('click', function () {
        var idx = parseInt($y.data('index'), 10);
        setJourneyActive(idx);
        scrollToCard(idx);
      });
    });
    $jrCards.each(function () {
      var $c = $(this);
      $c.on('click', function () { setJourneyActive(parseInt($c.data('index'), 10)); });
    });
    $('#journey-prev').on('click', function () { setJourneyActive(jrIndex - 1); scrollToCard(jrIndex); });
    $('#journey-next').on('click', function () { setJourneyActive(jrIndex + 1); scrollToCard(jrIndex); });

    /* ---------- Certification modal ---------- */
    var $certModal = $('#cert-modal');
    $('.js-cert-open').on('click', function () {
      var $btn = $(this);
      $('#cert-modal-name').text($btn.data('name'));
      $('#cert-modal-sub').text($btn.data('sub'));
      $('#cert-modal-img').attr('src', $btn.data('img')).attr('alt', $btn.data('name'));
      $certModal.addClass('open');
    });
    function closeCertModal() { $certModal.removeClass('open'); }
    $('#cert-modal-backdrop').on('click', closeCertModal);
    $('#cert-modal-close').on('click', closeCertModal);

    /* ---------- Reviews scroll buttons ---------- */
    var $reviewsTrack = $('#reviews-track');
    if ($reviewsTrack.length) {
      $('#reviews-prev').on('click', function () { $reviewsTrack.animate({ scrollLeft: '-=340' }, 300); });
      $('#reviews-next').on('click', function () { $reviewsTrack.animate({ scrollLeft: '+=340' }, 300); });
    }

    /* ---------- FAQ accordion (single open at a time) ---------- */
    var $faqItems = $('.sk-faq-item');
    $faqItems.each(function () {
      var $item = $(this);
      var $toggle = $item.find('.js-faq-toggle');
      if (!$toggle.length) return;
      $toggle.on('click', function () {
        var willOpen = !$item.hasClass('open');
        $faqItems.removeClass('open').find('.js-faq-toggle').attr('aria-expanded', 'false');
        if (willOpen) {
          $item.addClass('open');
          $toggle.attr('aria-expanded', 'true');
        }
      });
    });
  });
})(jQuery);
